import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Toast.module.css';
export function Toast({ message, kind = 'info' }) {
    if (!message)
        return null;
    return (_jsx("div", { className: styles.container, children: _jsxs("div", { className: styles.toast, children: [_jsx("div", { className: `${styles.dot} ${kind === 'error' ? styles.dotError : ''}` }), message] }) }));
}
